import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { Select } from '../../../common/components';
import { useSetLoading } from '../../../common/hooks/appearance';
import { apiErrorHandler } from '../../../utils/handlers';
import { asyncDebounce } from '../../../utils/utils';

const AutoCompleteDropdown = (props) => {
  const {
    name,
    selection,
    setSelection,
    dropdownPlaceholder,
    formInput,
    apiMethod,
    responseFormatter,
    loadDefault,
    loadOnClear,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchData = async (searchVal) => {
    setLoading(true);
    try {
      const params = {
        searchValue: searchVal || '',
        page: 1,
        limit: 15,
      };
      const response = await apiMethod(params);
      const formatedResp = response.data.data.map(responseFormatter);
      setData(formatedResp);
      setLoading(false);
      return formatedResp; // this is required for search, loadOptions of Select expects return value
    } catch (err) {
      setLoading(false);
      apiErrorHandler(err);
    }
  };

  useEffect(() => {
    if (loadDefault) fetchData();
  }, [loadDefault]);

  const debounceApiCall = asyncDebounce(fetchData, 1000);

  const handleSelectChange = (selectedOption, triggeredAction) => {
    if (triggeredAction.action === 'clear' && loadOnClear) {
      // handle logic on click of clear
      fetchData();
    }
    setSelection(selectedOption);
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <div className="common-local-search w-100">
      <i className="fas fa-search" />
      <Select
        name={name}
        formInput={formInput}
        classNamePrefix="select-dropdown"
        placeholder={dropdownPlaceholder}
        onChange={handleSelectChange}
        value={selection}
        size="lg"
        isClearable
        cacheOptions
        isAsync
        loadOptions={debounceApiCall}
        defaultOptions={data}
      />
    </div>
  );
};

AutoCompleteDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  selection: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  setSelection: PropTypes.func,
  dropdownPlaceholder: PropTypes.string,
  formInput: PropTypes.bool,
  apiMethod: PropTypes.func.isRequired,
  responseFormatter: PropTypes.func.isRequired,
  loadDefault: PropTypes.bool,
  loadOnClear: PropTypes.bool,
};

AutoCompleteDropdown.defaultProps = {
  selection: null,
  setSelection: () => {},
  dropdownPlaceholder: 'Select',
  formInput: false,
  loadDefault: false,
  loadOnClear: false,
};

export default AutoCompleteDropdown;
